import React from 'react';
import { IconBox} from '../../../../components/molecules';
import IconBoxII from '../../../../components/molecules/IconBoxII/IconBoxII';
import viewIcon from '../../../../assets/images/view-icon.svg';
import acceptIcon from '../../../../assets/images/accept-icon.svg';
import declineIcon from '../../../../assets/images/decline-icon.svg';
import serviceIcon from '../../../../assets/images/serviceIcon.png';
import productIcon from '../../../../assets/images/productIcon.png';
import memorabiliaIcon from '../../../../assets/images/memorabilia-icon.svg';

export const NewOrdersRow = ({ customerName,
    orderValue,
    orderDate,
    orderRef,
    viewOnClick,
    acceptOnClick,
    declineOnClick,
    acceptText = "Accept",
    isService,
    isMemorabilia
}) => {
    return (
        <div className='order-row'>
          <div className='d-flex gap-3 w-100 justify-content-between'>
            <div className='d-flex flex-column flex-sm-row gap-5'>
              {/* <div>
              <IconBoxII icon={isService? serviceIcon : productIcon} title="" tooltip={isService ? "Service Order" : "Physical Product Order"}  />
                </div> */}
                <div className="gap-4" style={{alignItems:'center', justifyContent:'center', display:'flex', flexDirection:'row', flexWrap:'wrap' }}>
                  <img src={isService ? serviceIcon : isMemorabilia ? memorabiliaIcon : productIcon} style={{width:isService ?'18px' : isMemorabilia ? '26px' : '24px', height:isService ?'18px' : isMemorabilia ? '26px' : '24px', display:'flex', marginLeft:'3px'}}></img>
                  
                  <div style={{display:'flex', flexDirection:'column'}}>
                    <p className='label'>Order Ref</p>
                    <p className='text'>{orderRef}</p>
                  </div>
                </div>
                <div>
                    <p className='label'>Customer name</p>
                    <p className='text'>{customerName}</p>
                </div>
            </div>
            <div className='d-flex flex-column flex-sm-row gap-5'>
              <div>
                  <p className='label'>Order value</p>
                  <p className='text'>{`\u00A3${orderValue}`}</p>
              </div>
              <div>
                  <p className='label'>Order date</p>
                  <p className='text'>{orderDate}</p>
              </div>
            </div>
          </div>
          <div className='d-flex flex-sm-row flex-column space-left'>
            <IconBox icon={viewIcon} subtitle="View" onClick={viewOnClick} />
            <IconBox icon={acceptIcon} subtitle={acceptText} onClick={acceptOnClick} />
            <IconBox icon={declineIcon} subtitle="Decline" onClick={declineOnClick} />
          </div>
        </div>
    )
}
